"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCategorisationMifCorporation = void 0;
exports.ESubCategorisationMifCorporation = {
    professionnel: "professionnel",
    non_professionnel: "non_professionnel",
};
